import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    billingData: null,
}

const billingSlice = createSlice({
    name: "billing",
    initialState,
    reducers: {
        setBillingData: (state, action) => {
            console.log("Setting billing data:", action.payload)
            state.billingData = action.payload
            console.log("Billing data set successfully")
            console.log("Current billing data:", state.billingData)
        },
    },
})

export const { setBillingData } = billingSlice.actions
export default billingSlice.reducer
